import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

// Restores the browser’s "hash anchor → scroll to element" behaviour for
// SPA navigations. Without this, clicking a footer Link like
// `to="/for-workers#fastpay"` updates the URL but lands you at the top of
// the page — only full page loads honour the hash by default.
//
// Defers the scroll one tick so the destination route has finished
// rendering before we try to find the element. If the element doesn’t
// exist (anchor on a different page that isn’t mounted yet), we no-op
// silently.

export default function ScrollToHash() {
  const { pathname, hash } = useLocation()

  useEffect(() => {
    if (!hash) {
      // Plain navigation — scroll to top so a fresh page doesn’t inherit
      // the previous page’s scroll position.
      window.scrollTo({ top: 0, behavior: 'instant' })
      return
    }
    // Strip the leading '#' and let the route mount before searching.
    const id = hash.slice(1)
    const tick = setTimeout(() => {
      const el = document.getElementById(id)
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
    }, 0)
    return () => clearTimeout(tick)
  }, [pathname, hash])

  return null
}
